<template>
  <v-dialog
  v-model="dialog"
  max-width="800"
  persistent
>
  <v-card>
    <v-card-title class="title pt-5 pb-0">
      Pagamento via PIX
    </v-card-title>

    <v-card-text class="pt-2 pb-4 text-center">
      <p class="mb-4">Escaneie o QR Code ou copie o código para pagamento:</p>

      <div class="mb-4">
        <v-img
          :src="qrCodeUrl"
          max-width="300"
          max-height="300"
          class="mx-auto"
          contain
        />
      </div>

      <v-text-field
        v-model="codigoPix"
        label="Código PIX (Copiar e Colar)"
        outlined
        readonly
        class="mb-4"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="copiarCodigo"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copiar código</span>
          </v-tooltip>
        </template>
      </v-text-field>

      <v-alert
        v-if="mensagemProcessamento"
        type="info"
        class="mb-4"
      >
        {{ mensagemProcessamento }}
      </v-alert>
    </v-card-text>

    <v-card-actions class="pt-0 pb-4">
      <v-spacer />
      <v-btn color="grey" text @click="dialog = false">Cancelar</v-btn>
      <v-btn color="primary" text @click="trocarFormaPagamento">Trocar Forma de Pagamento</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'ModalPagamentoPix',
  props: {
    value: Boolean,
    compraId: Number,
    // These props are correctly named to match the data sent from the parent
    qrCode: String,
    codigoPix: String,
  },
  data() {
    return {
      loading: false,
      mensagemProcessamento: '',
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    qrCodeUrl() {
      return this.qrCode || '';
    },
  },
  methods: {
    copiarCodigo() {
      navigator.clipboard.writeText(this.codigoPix);
      this.$toast.success('Código PIX copiado!');
    },
    trocarFormaPagamento() {
      this.$router.push('/meu-perfil/cartoes-credito');
      this.dialog = false;
    },
    async confirmarPagamento() {
      this.dialog = false;
      this.$emit('dataUpdated');
    },
  },
};
</script>